import {gql, useLazyQuery} from '@apollo/client';

import {AVAILABLE_FEES_FRAGMENT} from '../../../graphql/fragments';
import {
  BuilderGetAvailableFees,
  BuilderGetAvailableFeesVariables,
} from '../../../schema-types/BuilderGetAvailableFees';

export const useBuilderAvailableFees = () => {
  const [getAvailableFees, {data, loading: feesLoading}] = useLazyQuery<
    BuilderGetAvailableFees,
    BuilderGetAvailableFeesVariables
  >(
    gql`
      query BuilderGetAvailableFees(
        $productId: UUID!
        $accountId: UUID!
        $providerId: UUID!
        $mandateId: UUID
        $hasSubplan: Boolean!
        $parentProductId: UUID
      ) {
        availableFeeComponentsDentist(
          accountId: $accountId
          productId: $productId
          providerId: $providerId
          mandateId: $mandateId
          hasSubplan: $hasSubplan
          parentProductId: $parentProductId
        ) {
          fpFees {
            ...AvailableFeeFragment
          }
          dfmFees {
            ...AvailableFeeFragment
          }
          productFees {
            ...AvailableFeeFragment
          }
          sippFees {
            ...AvailableFeeFragment
          }
        }
        planFees(accountId: $accountId) {
          fpFees {
            ...AvailableFeeFragment
          }
          dfmFees {
            ...AvailableFeeFragment
          }
          productFees {
            ...AvailableFeeFragment
          }
        }
        feeComponents(
          productId: $productId
          providerId: $providerId
          parentProductId: $parentProductId
        ) {
          fpFees {
            ...AvailableFeeFragment
          }
          dfmFees {
            ...AvailableFeeFragment
          }
          productFees {
            ...AvailableFeeFragment
          }
        }
      }
      ${AVAILABLE_FEES_FRAGMENT}
    `,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only',
    }
  );

  return {
    getAvailableFees,
    feesLoading,
    data,
  };
};
